<template>
  <el-row
    ><el-col :lg="3">
      <el-button @click="goBack" type="primary" size="medium"> Back </el-button>
    </el-col>
    <el-col :lg="18">
      <div class="form-container">
        <div class="form-header">
          <img :src="iconsUrl + appSelected.logo" class="app-logo" />
          <h2 class="form-title">{{ appSelected.label }}</h2>
        </div>
        <el-divider />
        <el-form class="form-body" label-position="top">
          <el-form-item
            label="Connection Name"
            class="form-item"
            :error="fieldErrors.connectionName"
          >
            <el-input
              v-model="connectionName"
              placeholder=""
              class="form-input"
            />
          </el-form-item>
          <el-form-item
            v-for="field in appSelected.settings?.authenticationFields || []"
            :key="field.key"
            :label="field.label"
            class="form-item"
            :error="fieldErrors[field.key]"
          >
            <el-input
              v-model="authenticationFields[field.key]"
              :type="field.type || 'text'"
              placeholder=""
              class="form-input"
            />
          </el-form-item>
        </el-form>
        <el-row
          ><el-col>
            <el-button type="primary" @click="connectNonOauthApp">
              Save
            </el-button></el-col
          ></el-row
        >
      </div>
    </el-col>
  </el-row>
</template>
<script>
import store from "@/store/index";
import { mapGetters } from "vuex";
export default {
  name: "integrationsNonOauthApplications",
  props: {
    showNonOauth: Boolean,
    appSelected: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      connectionName: "",
      authenticationFields: {},
      fieldErrors: {},
      apiMessage: "",
      apiSuccess: false,
    };
  },
  computed: {
    ...mapGetters("globalApis", ["getvalidateNonOauthCredentials"]),
    iconsUrl() {
      return process.env.VUE_APP_ICONS_BASE_URL;
    },
  },
  methods: {
    goBack() {
      let params = {
        redirect_url: this.$route.query.redirect_url,
        state: this.$route.query.state,
      };
      this.$router.push({
        path: "/all-integrations",
        query: params,
      });
    },
    async connectNonOauthApp() {
      this.fieldErrors = {};
      this.apiMessage = "";
      this.apiSuccess = false;
      let hasError = false;
      if (!this.connectionName.trim()) {
        this.fieldErrors.connectionName = "Connection Name is required.";
        hasError = true;
      }
      const authFields = this.appSelected.settings?.authenticationFields || [];
      for (const field of authFields) {
        const value = this.authenticationFields[field.key];
        if (!value || value.toString().trim() === "") {
          this.fieldErrors[field.key] = `${field.label} is required.`;
          hasError = true;
        }
      }
      if (hasError) return;
      const payload = {
        appId: this.appSelected?._id,
        authenticationFields: this.authenticationFields,
        name: this.connectionName,
        state: this.$route.query.state,
      };
      try {
        await store.dispatch(
          "globalApis/getvalidateNonOauthCredentials",
          payload
        );
        this.apiSuccess = true;
        this.apiMessage = "Connection established successfully.";
        this.$notify({
          title: "Success",
          message: this.apiMessage,
          type: "success",
        });
        if (
          this.appSelected.settings &&
          this.appSelected.settings.requiredFields &&
          this.appSelected.settings.requiredFields.length
        ) {
          this.$emit(
            "activateConnection",
            this.getvalidateNonOauthCredentials.data
          );
        } else {
          window.open(
            `${this.$route.query.redirect_url}?state=${this.$route.query.state}`,
            "_self"
          );
        }
      } catch (error) {
        const message = error?.response?.data?.message?.toLowerCase?.() || "";
        if (message.includes("invalid credentials")) {
          this.apiMessage =
            "Invalid credentials. Please check your username and password.";
        } else {
          this.apiMessage =
            "Unable to establish the connection. Please try again later.";
        }
        this.apiSuccess = false;
        this.$notify({
          title: "Error",
          message: this.apiMessage,
          type: "error",
        });
      }
      setTimeout(() => {
        this.apiMessage = "";
      }, 5000);
    },
  },
};
</script>
<style scoped>
.form-container {
  background: #ffffff;
  width: 100%;
  /* max-width: 900px; */
  padding: 10%;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  margin: 0 auto;
}
/* .form-header {
  text-align: center;
  margin-bottom: 30px;
} */
.app-logo {
  width: 60px;
  height: 60px;
}
.form-title {
  font-size: 22px;
  font-weight: 600;
  margin-top: 12px;
  color: #111827;
}
/* .form-body {
  display: flex;
  flex-direction: column;
} */
::v-deep(.el-form-item__label) {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin-bottom: 6px;
}
.form-item {
  margin-bottom: 20px;
}
.form-input ::v-deep(.el-input__inner) {
  font-size: 14px;
  padding: 10px 14px;
  border-radius: 6px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  color: #111827;
  height: 38px;
  box-shadow: none;
  transition: background-color 0.2s ease;
}
.form-input ::v-deep(.el-input__inner:focus),
.form-input ::v-deep(.el-input__inner:not(:placeholder-shown)) {
  background-color: #ffffff !important;
  border-color: #e5e7eb !important;
  box-shadow: none !important;
  outline: none;
}
::v-deep(.el-input__wrapper) {
  border-radius: 6px;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}
::v-deep(.el-input__wrapper.is-focus) {
  border-color: #e5e7eb !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
.error-msg {
  color: #dc2626;
  font-size: 13px;
  margin-top: -12px;
  margin-bottom: 20px;
}
/* .form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
} */
</style>
